const PARENT_POST_AUTH_REDIRECT_KEY = "parentPostAuthRedirect";
const AUTH_SESSION_MODE_KEY = "authSessionMode";

export const PARENT_DEFAULT_REDIRECT_PATH = "/tutorinfo";
export const PARENT_BOOKING_HUB_PATH = "/parent/classBooking/bookTutor";
export const AUTH_SESSION_MODES = {
  STUDENT: "student",
  PARENT: "parent",
};
export const BOOKING_SOURCES = {
  STUDENT: "student",
  PARENT: "parent",
};

export const normalizeParentRedirectPath = (
  value,
  fallback = PARENT_DEFAULT_REDIRECT_PATH
) => {
  const normalizedValue = String(value || "").trim();

  if (!normalizedValue.startsWith("/")) {
    return fallback;
  }

  if (normalizedValue.startsWith("//")) {
    return fallback;
  }

  return normalizedValue;
};

export const persistParentPostAuthRedirect = (
  value = PARENT_DEFAULT_REDIRECT_PATH
) => {
  const nextPath = normalizeParentRedirectPath(value);

  try {
    sessionStorage.setItem(PARENT_POST_AUTH_REDIRECT_KEY, nextPath);
  } catch (_error) {
    // Ignore storage failures. The parent flow can still continue.
  }

  return nextPath;
};

export const readParentPostAuthRedirect = (
  fallback = PARENT_DEFAULT_REDIRECT_PATH
) => {
  try {
    return normalizeParentRedirectPath(
      sessionStorage.getItem(PARENT_POST_AUTH_REDIRECT_KEY),
      fallback
    );
  } catch (_error) {
    return fallback;
  }
};

export const clearParentPostAuthRedirect = () => {
  try {
    sessionStorage.removeItem(PARENT_POST_AUTH_REDIRECT_KEY);
  } catch (_error) {
    // Ignore storage failures.
  }
};

const writeAuthSessionMode = (mode = "") => {
  try {
    if (mode) {
      localStorage.setItem(AUTH_SESSION_MODE_KEY, mode);
      sessionStorage.setItem(AUTH_SESSION_MODE_KEY, mode);
      return;
    }

    localStorage.removeItem(AUTH_SESSION_MODE_KEY);
    sessionStorage.removeItem(AUTH_SESSION_MODE_KEY);
  } catch (_error) {
    // Ignore storage failures.
  }
};

export const persistParentSessionMode = () => {
  writeAuthSessionMode(AUTH_SESSION_MODES.PARENT);
  return AUTH_SESSION_MODES.PARENT;
};

export const persistStudentSessionMode = () => {
  writeAuthSessionMode(AUTH_SESSION_MODES.STUDENT);
  return AUTH_SESSION_MODES.STUDENT;
};

export const readAuthSessionMode = () => {
  try {
    const storedMode =
      sessionStorage.getItem(AUTH_SESSION_MODE_KEY) ||
      localStorage.getItem(AUTH_SESSION_MODE_KEY) ||
      "";

    if (
      storedMode === AUTH_SESSION_MODES.PARENT ||
      storedMode === AUTH_SESSION_MODES.STUDENT
    ) {
      return storedMode;
    }
  } catch (_error) {
    // Ignore storage failures.
  }

  return "";
};

export const clearAuthSessionMode = () => {
  writeAuthSessionMode("");
};

export const isParentSessionMode = () =>
  readAuthSessionMode() === AUTH_SESSION_MODES.PARENT;

export const isParentFlowPath = (pathname = "") =>
  String(pathname || "").startsWith("/parent/");

export const isParentBookingFlowPath = (pathname = "") =>
  String(pathname || "").startsWith("/parent/classBooking");

export const getClassBookingBasePath = (pathname = "") =>
  isParentBookingFlowPath(pathname) ? "/parent/classBooking" : "/classBooking";

export const getBookingSourceFromPath = (pathname = "") =>
  isParentBookingFlowPath(pathname)
    ? BOOKING_SOURCES.PARENT
    : BOOKING_SOURCES.STUDENT;

export const canParentSessionAccessProtectedPath = (pathname = "") => {
  const normalizedPath = String(pathname || "").trim();

  return (
    isParentFlowPath(normalizedPath) ||
    normalizedPath === "/afterlogin" ||
    normalizedPath === "/subscription"
  );
};
